/**
 * Emailed links carry one-time tokens in the URL fragment (#token=…), which browsers never send to servers or
 * proxies. We read it once and immediately remove it from the address bar and history.
 */
export function takeHashToken(): string | null {
  const match = /(?:^#|&)token=([^&]+)/.exec(window.location.hash);
  if (!match?.[1]) return null;
  history.replaceState(null, '', window.location.pathname + window.location.search);
  return decodeURIComponent(match[1]);
}
